import { render, staticRenderFns } from "./contact-card.vue?vue&type=template&id=29cbcebe&scoped=true&"
import script from "./contact-card.vue?vue&type=script&lang=js&"
export * from "./contact-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbcebe",
  null
  
)

export default component.exports